export const getCurrentTimestamp = () => {
    const now = new Date();
    now.setMilliseconds(0);
    return now.getTime() / 1000;
}

export const getDateFromWeekday = (day) => {
    const dayToIndex = { 'Sunday': 0, 'Monday': 1, 'Tuesday': 2, 'Wednesday': 3, 'Thursday': 4 };
    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
    
    const apTime = new Date();
    return addDays(apTime, (dayToIndex[day] - apTime.getDay()));
}

export const getTimestamp = (time, day) => {
    const apTime = getDateFromWeekday(day);;
    const [hours, minutes] = time.split(':') || ([1, 1])
    apTime.setHours(hours);
    apTime.setMinutes(minutes);
    apTime.setSeconds(0);
    apTime.setMilliseconds(0);

    return apTime.getTime() / 1000;
}

export const getDatetimeFromDay = (time, day) => {
    const apTime = getDateFromWeekday(day);;
    const [hours, minutes] = time.split(':') || ([1, 1])
    apTime.setHours(hours);
    apTime.setMinutes(minutes);
    apTime.setSeconds(0);
    apTime.setMilliseconds(0);
    return apTime;
}


